<template>
  <div class="desktop invoices-table container" v-if="invoices.length != 0">
    <div class="invoice-row header">
      <span class="invoice-title">{{ t('invoices.title') }}</span>
      <span class="invoice-title">{{ t('invoices.paid') }}</span>
      <span class="invoice-title">{{ t('invoices.amount') }}</span>
      <span class="invoice-title">{{ t('invoices.files') }}</span>
    </div>
    <div class="invoice-row bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue ml-3.5 rounded-8xl"
      v-for="invoice in invoices" :key="invoice.uuid">
      <span class="invoice-cell flex gap-2 font-bold">
        <img src="@/assets/icons/svg/Invoice_24x24.svg" alt="Suitcase">
        {{ invoice.title }}
      </span>
      <span class="invoice-cell">{{ userStore.formatDate(invoice.paid)}}</span>
      <span class="invoice-cell font-bold">€ {{ invoice.amount }}</span>
      <span class="invoice-cell">
        <button class="download-btn" @click="downloadReceipt(invoice.file)">
          {{ t('invoices.downloadReceipt') }}
        </button>
      </span>
    </div>
  </div>

  <div v-else class="container flex justify-center items-center h-full gap-5 min-h-[400px] alignBoxClass">
    <div class="flex flex-col bg-background-light boxClass justify-between rounded-8xl p-5 pr-16">
      <div>
        <img src="@/assets/icons/svg/Invoice_40x40.svg" alt="Suitcase">
      </div>
      <div class=" responsive-body-large font-semibold">{{ t('invoices.noBillings') }}</div>
    </div>
  </div>

  <div class="container mobile" v-if="invoices.length != 0">
    <div class="invoice-row flex-col bg-gradient-to-r from-gradients-ghostWhite to-gradients-aliceBlue m-3.5 rounded-8xl"
      v-for="invoice in invoices" :key="invoice.uuid">
      <span class="invoice-cell flex gap-2 font-bold">
        <img src="@/assets/icons/svg/Invoice_24x24.svg" alt="Suitcase">
        {{ t('invoices.invoicePrefix') }}{{ invoice.title }}
      </span>
      <div class="flex">
        <div class="invoice-cell">
          <div class="responsive-body-xsmall">{{ t('invoices.date') }}</div>
          <div class="text-sm">{{ userStore.formatDate(invoice.paid) }}</div>
        </div>
        <div class="invoice-cell ">
          <div class="responsive-body-xsmall">{{ t('invoices.amountLabel') }}</div>
          <div class="text-sm">€ {{ invoice.amount }}</div>
        </div>
      </div>
      <div class="invoice-cell">
        <button class="download-btn text-sm" @click="downloadReceipt(invoice.file)">
          {{ t('invoices.downloadReceipt') }}
        </button>
      </div>
    </div>
  </div>

  <div v-else
    class=" mobile container flex justify-center items-center h-full gap-5 min-h-[400px] alignBoxClass pt-4">
    <div class="flex flex-col bg-background-light boxClass justify-between rounded-8xl p-5 pr-16">
      <div>
        <img src="@/assets/icons/svg/Invoice_40x40.svg" alt="Suitcase">
      </div>
      <div class=" responsive-body-large font-semibold">{{ t('invoices.noBillings') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { getBilling } from "@/api";
import { Invoice } from "@/models/Invoice";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/userStore"; // Import the userStore

const userStore = useUserStore(); 

const { t } = useI18n();
const invoices = ref<Invoice[]>([]);

onMounted(() => {
  getBilling().then(response => {
    invoices.value = response.data;
  });
});

function downloadReceipt(link: string) {
  window.open(link, '_blank');
}
</script>

<style scoped>
.invoices-container {
  max-width: 100%;
}

.invoices-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 8px;
}

.invoice-row {
  display: flex;
}

.header {
  font-weight: bold;
}

.invoice-cell {
  padding: 16px;
  flex: 1;
  text-align: left;
}

.invoice-title {
  font-size: 12px;
  flex: 1;
  text-align: left;
  padding: 0 15px;
}

.download-btn {
  text-decoration: underline;
  font-weight: 600;
}

.boxClass {
  min-width: 200px;
  max-width: 220px;
  min-height: 240px;
  max-height: 260px;
}

@media (max-width: 768px) {
  .alignBoxClass {
    min-height: unset;
    height: unset;
  }

  .boxClass {
    min-height: 170px;
    max-height: 190px;
  }

  .boxClass div {
    font-size: 16px;
  }

  .desktop {
    display: none;
  }

  .mobile {
    display: flex;
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }
}
</style>
